import React from 'react';
import { TMaterialTableColumns } from 'components/table/index.types';
import { TAdminActivityLog } from 'types/entities/admin-activity-logs';
import timeFormat from 'utils/time-format';
import PendingTaskReadableStatus from 'app/private/containers/pending-tasks/components/PendingTaskReadableStatus';
import { toSentenceCaseFormat } from 'utils/sentence-case-format';

const adminActivityLogColumns =
    (): TMaterialTableColumns<TAdminActivityLog> => [
        {
            width: '50',
            key: 'id',
            title: 'Log ID',
        },
        {
            width: '50',
            key: 'createdAt',
            title: 'Created At',
            render: (props) => {
                return <span>{timeFormat(props.rowData.createdAt)}</span>;
            },
        },
        {
            width: '70',
            key: 'adminEmail',
            title: 'Admin Email',
        },
        {
            width: '70',
            key: 'actionType',
            title: 'Action Type',
            render: (props) => (
                <>
                    {props.rowData.pendingTaskStatus !== null
                        ? 'Pending Task - '
                        : ''}{' '}
                    {toSentenceCaseFormat(props.rowData.actionType)}
                </>
            ),
        },
        {
            width: '30',
            key: 'actionLevel',
            title: 'Action Level',
            render: (props) => (
                <>{toSentenceCaseFormat(props.rowData.actionLevel)}</>
            ),
        },
        {
            width: '50',
            key: 'relatedUserNexId',
            title: 'User Nex ID',
        },
        {
            width: '50',
            key: 'pendingTaskStatus',
            title: 'Pending Task Status',
            render: (props) => (
                <PendingTaskReadableStatus
                    rawStatus={props.rowData.pendingTaskStatus}
                />
            ),
        },
    ];

export default adminActivityLogColumns;
